import { ICompany } from '@/bundles/Companies/types';
import store from '@/store/store';
import Account from '@/bundles/Account/models/Account';
import { Nullable } from '@/utils/types';

export const getCompanyDefaultPhoneObj = () => ({
  office: '',
  office_country_code: '',
  fax: '',
  fax_country_code: '',
});

export const getAccountCountry = () => {
  return (store.state.activeAccount as Nullable<Account>)?.country?.toUpperCase() || 'US';
}

export const getCompanyDefaultObj = (): Omit<ICompany, 'location'> => ({
  _id: '',
  _key: '',
  name: '',
  logo: '',
  url: '',
  description: '',
  address: {
    street: '',
    street2: '',
    city: '',
    state: '',
    postal: '',
    country: getAccountCountry(),
    timezone_name: null,
  },
  phone: getCompanyDefaultPhoneObj(),
  isBrokerage: false,
  brokerLicense: {
    legal_name: '',
    number: '',
    state: '',
    taxId: ''
  },
  industry_group: '',
  industry: '',
  metrics: {
    employees: '',
    annualRevenue: '',
    estimatedAnnualRevenue: ''
  },
  created: {
    name: ''
  },
  updated: {
    name: ''
  },
  active: true,
  year_established: '',
  contacts: [],
  notes: [],
  tasks: [],
  name_history: [],
  site: {
    coordinates: {
      lng: null,
      long: null,
      lat: null,
    }
  },
});
